import confetti from 'canvas-confetti';


export type ConfettiOrigin = {
  x?: number; // 0 → 1 (left → right)
  y?: number; // 0 → 1 (top → bottom)
};


const COUPON_CONFETTI_COLORS = [
  '#99834D', // gold
  '#B79A5A', // light gold
  '#301250', // deep purple
  '#22C55E', // green
  '#3B82F6', // blue
  '#F59E0B', // amber
  '#EC4899', // pink
  '#A855F7', // violet
];

const SPARKLE_COLORS = [
  '#ffffff',
  '#FDE68A',
  '#E9D5FF',
];


export const fireCouponConfetti = (
  origin: ConfettiOrigin = { x: 0.5, y: 0.65 }
) => {
  if (typeof window === 'undefined') return;


  confetti({
    particleCount: 180,
    spread: 90,
    startVelocity: 45,
    decay: 0.88,
    scalar: 1,
    origin,
    colors: COUPON_CONFETTI_COLORS,
  });


  setTimeout(() => {
    confetti({
      particleCount: 60,
      spread: 60,
      startVelocity: 30,
      scalar: 0.7,
      origin: {
        x: origin.x ?? 0.5,
        y: (origin.y ?? 0.65) - 0.05,
      },
      colors: SPARKLE_COLORS,
    });
  }, 150);
};


export const fireConfettiFromElement = (element: HTMLElement) => {
  if (!element || typeof window === 'undefined') return;

  const rect = element.getBoundingClientRect();

  const x = (rect.left + rect.width / 2) / window.innerWidth;
  const y = (rect.top + rect.height / 2) / window.innerHeight;

  fireCouponConfetti({ x, y });
};
